// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2R5QD","radioRow":"SimpleQuestionBuilderModal_radioRow__3-YDl"};